import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import SectionHeader from '../components/SectionHeader';
import { heroSlides, factItems, services, testimonials, blogPosts, companyDescription } from '../data/content';

function Home() {
  return (
    <div className="home-page">
      <Carousel slides={heroSlides} />

      <section className="fact-section">
        <div className="container-grid">
          {factItems.map((item) => (
            <div key={item.title} className="fact-card">
              <div className="fact-icon">{item.icon}</div>
              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </section>

      <section id="about" className="content-section">
        <SectionHeader label="Learn About Us" title="10+ Years Experience" />
        <div className="content-grid">
          <div className="content-card large-card">
            <p>
              {companyDescription}
            </p>
            <Link to="/about" className="btn btn-primary">
              Learn More
            </Link>
          </div>
          <div className="content-card image-card">
            <div className="image-placeholder">About image</div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <SectionHeader label="Consulting Services" title="Our Best Consulting Services" />
        <div className="card-grid">
          {services.slice(0, 6).map((service) => (
            <div key={service.title} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <Link to="/service" className="link-button">
                Read More
              </Link>
            </div>
          ))}
        </div>
      </section>

      <section className="content-section alt-background">
        <SectionHeader label="Testimonials" title="What our clients say" />
        <div className="testimonial-grid">
          {testimonials.map((item) => (
            <div key={item.author} className="testimonial-card">
              <p>“{item.quote}”</p>
              <strong>{item.author}</strong>
            </div>
          ))}
        </div>
      </section>

      <section className="content-section">
        <SectionHeader label="Latest News" title="Insights from our blog" />
        <div className="card-grid">
          {blogPosts.map((post) => (
            <div key={post.title} className="blog-card">
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
              <Link to="/blog" className="link-button">
                Read More
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
